<template>
  <div id="app">
    <div class="container">
      <AddCardToSequenceModal v-if="showAddCardToSequenceModal"/>
      <AddMediaToCardModal v-if="showAddMediaToCardModal"/>
      <AddSequenceToPolicyModal v-if="showAddSequenceToPolicyModal"/>
      <ColdDeckResetModal v-if="showColdDeckModal"/>
      <CreateCardLocalRecordModal v-if="showCreateCardLocalRecordModal"/>
      <CopyVolumeLinksModal v-if="showCopyVolumeLinksModal"/>
      <CopyCardLocalRecordModal v-if="showCopyLocalRecordModal"/>
      <CreateCardModal v-if="showCreateCardModal"/>
      <CreateMarketModal v-if="showCreateMarketModal"/>
      <CreateMediaLibraryLocalRecordModal v-if="showCreateMediaLibraryLocalRecordModal"/>
      <CreateMediaLibraryModal v-if="showCreateMediaLibraryModal"/>
      <CreateProductGroupModal v-if="showCreateProductGroupModal"/>
      <CreateProductLocalRecordModal v-if="showCreateProductLocalRecordModal"/>
      <CreateProductGroupLocalRecordModal v-if="showCreateProductGroupLocalRecordModal"/>
      <CreateProductModal v-if="showCreateProductModal"/>
      <DeprecateMediaModal v-if="showDeprecateMediaModal"/>
      <DeleteRecordModal v-if="showDeleteRecordModal"/>
      <EditHelpModal v-if="showCardHelpModal"/>
      <LogoutModal v-if="showLogoutModal"/>
      <MediaUploadModal v-if="showMediaUploadModal"/>
      <ProductImageUploadModal v-if="showUploadProductImageModal"/>
      <CardIconUploadModal v-if="showCardIconModal"/>
      <DeleteProductModal v-if="showDeleteProductModal"/>
      <RestoreProductModal v-if="showRestoreProductModal"/>
      <UpdateThumbModal v-if="showUpdateThumbModal"/>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import store from './store';
import router from './router';
import { getResource } from './services/Utils';
import Services from './services/Services.js';
import ls from 'local-storage';
import DeprecateMediaModal from './components/modals/DeprecateMedia';
import MediaUploadModal from './components/modals/MediaUpload';
import AddMediaToCardModal from './components/modals/AddMediaToCard';
import AddSequenceToPolicyModal from './components/modals/AddSequenceToPolicy';
import AddCardToSequenceModal from './components/modals/AddCardToSequence';
import UpdateThumbModal from './components/modals/UpdateThumb';
import DeleteRecordModal from './components/modals/DeleteRecord';
import EditHelpModal from './components/modals/EditCardHelp';
import CreateCardModal from './components/modals/CreateActionCard';
import CreateCardLocalRecordModal from './components/modals/CreateCardLocalRecord';
import CopyCardLocalRecordModal from './components/modals/CopyCardLocalRecord';
import CopyVolumeLinksModal from './components/modals/CopyVolumeLinks';
import CreateMediaLibraryModal from './components/modals/CreateMediaLibrary';
import CreateMediaLibraryLocalRecordModal from './components/modals/CreateMediaLibraryLocalRecord';
import CreateProductLocalRecordModal from './components/modals/CreateProductLocalRecord';
import CreateProductGroupLocalRecordModal from './components/modals/CreateProductGroupLocalRecord';
import ProductImageUploadModal from './components/modals/ProductImageUpload';
import CardIconUploadModal from './components/modals/CardIconUpload';
import CreateProductGroupModal from './components/modals/CreateProductGroup';
import CreateProductModal from './components/modals/CreateProduct';
import CreateMarketModal from './components/modals/CreateMarket';
import ColdDeckResetModal from './components/modals/ColdDeckReset';
import DeleteProductModal from './components/modals/DeleteProduct';
import RestoreProductModal from './components/modals/RestoreProduct';
import LogoutModal from './components/modals/Logout';
import VueNotifications from 'vue-notifications';
export default {
  name: 'app',
  created() {
    /**
     * Set the environment
     */
    store.commit('setEnv');
  },
  components: {
    AddMediaToCardModal,
    AddSequenceToPolicyModal,
    AddCardToSequenceModal,
    DeprecateMediaModal,
    MediaUploadModal,
    UpdateThumbModal,
    ColdDeckResetModal,
    DeleteProductModal,
    RestoreProductModal,
    CreateMarketModal,
    CreateProductModal,
    DeleteRecordModal,
    CreateProductGroupModal,
    LogoutModal,
    EditHelpModal,
    CreateCardModal,
    CreateCardLocalRecordModal,
    CopyVolumeLinksModal,
    CopyVolumeLinksModal,
    CopyCardLocalRecordModal,
    CreateProductLocalRecordModal,
    CreateProductGroupLocalRecordModal,
    CreateMediaLibraryModal,
    CreateMediaLibraryLocalRecordModal,
    ProductImageUploadModal,
    CardIconUploadModal
  },
  computed: {
    showAddCardToSequenceModal() {
      return store.getters.getShowAddCardToSequenceModal;
    },
    showAddSequenceToPolicyModal() {
      return store.getters.getShowAddSequenceToPolicyModal;
    },
    showAddMediaToCardModal() {
      return store.getters.getShowAddMediaToCardModal;
    },
    showDeprecateMediaModal() {
      return store.getters.getShowDeprecateMediaModal;
    },
    showMediaUploadModal() {
      return store.getters.getShowUploadMediaModal;
    },
    showUpdateThumbModal() {
      return store.getters.getShowUpdateThumbModal;
    },
    showColdDeckModal() {
      return store.getters.getShowColdDeckModal;
    },
    showDeleteRecordModal(){
        return store.getters.getShowDeleteRecord;
    },
    showLogoutModal() {
      return store.getters.getShowLogoutModal;
    },
    showDeleteProductModal() {
      return store.getters.getShowDeleteProductModal;
    },
    showRestoreProductModal() {
      return store.getters.getShowRestoreProductModal;
    },
    showCardHelpModal() {
      return store.getters.getShowCardHelpModal;
    },
    showCreateCardModal() {
      return store.getters.getShowCreateCardModal;
    },
    showCreateCardLocalRecordModal() {
      return store.getters.getShowCreateLocalRecord;
    },
    showCopyVolumeLinksModal(){
        return store.getters.getShowCopyVolumeLinks;
    },
    showCopyLocalRecordModal(){
        return store.getters.getShowCopyLocalRecord;
    },
    showCreateMediaLibraryModal() {
      return store.getters.getShowCreateMediaLibrary;
    },
    showCreateMediaLibraryLocalRecordModal() {
      return store.getters.getShowCreateMediaLibraryLocalRecord;
    },
    showCreateProductLocalRecordModal() {
      return store.getters.getShowCreateProductLocalRecord;
    },
    showCreateProductGroupLocalRecordModal() {
      return store.getters.getShowCreateProductGroupLocalRecord;
    },
    showCreateMarketModal() {
      return store.getters.getShowCreateMarket;
    },
    showCreateProductGroupModal() {
      return store.getters.getShowCreateProductGroup;
    },
    showCreateProductModal() {
      return store.getters.getShowCreateProduct;
    },
    showUploadProductImageModal() {
      return store.getters.getShowUploadProductImage;
    },
    showCardIconModal() {
      return store.getters.getShowCardIcon;
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data() {
    return {
      route: router.currentRoute.name,
      nonAuthRoutes: ['/', '/login', '/register', '/reset']
    };
  },
  methods: {
    getDomain(domain) {
      return new Promise((resolve, reject) => {
        getResource('/v1/tenants/domain')
          .then(res => {
            console.log(res);
            console.log(res);
            store.commit('setDomain', domain);
            if (res.status === 'success') {
              store.commit('setTenant', res.tenant);
              return resolve();
            }
            store.commit('setTenant', false);
            return reject(res);
          })
          .catch(err => {
            console.log(err);
            store.commit('setTenant', false);
            return reject(err);
          });
      });
    },
    logout(message) {
      store.commit('hideModals', true);
      ls.set('GEG__KEY', '');
      this.$router.push('/');
      this.showErrorMsg({ message: message ? message : 'You\'ve been logged out.' })
    },
    checkLogin() {
      const token = ls.get('GEG__KEY');
      const path = `/${router.currentRoute.name}`;

      // redirect to dashboard if logged in
      if (token && this.nonAuthRoutes.includes(path)) {
        router.push({ name: 'dashboard' });
      }
    }
  },
  mounted() {
    console.log(router.currentRoute.name);
    Services.getMediaAssociations();
    const str = window.location.host;
    const domain = str.split('.')[0];
    this.getDomain(domain)
      .then(this.checkLogin)
      .catch(error => console.log(error));
  },
  watch:{
    $route (to, from){
        const path = `/${router.currentRoute.name}`;
        console.log('path', path);

        if(!this.nonAuthRoutes.includes(path) && this.route !== 'login' && store.getters.getUser.status !== 'active') {
            //   not an active user
            console.log('not active user')
            this.logout('User is inactive.');
        }
        store.commit('hideModals', true);
    }
}
};
</script>

<style lang="scss">
// Fonts
@font-face {
  font-family: 'proxima_novalight';
  src: url('./assets/fonts/proximanova-light-webfont.eot');
  src: url('./assets/fonts/proximanova-light-webfont.eot?#iefix')
      format('embedded-opentype'),
    url('./assets/fonts/proximanova-light-webfont.woff2') format('woff2'),
    url('./assets/fonts/proximanova-light-webfont.woff') format('woff'),
    url('./assets/fonts/proximanova-light-webfont.ttf') format('truetype'),
    url('./assets/fonts/proximanova-light-webfont.svg#proxima_novalight')
      format('svg');
  font-weight: normal;
  font-style: normal;
}

$font__light: 'proxima_novalight', Arial, Helvetica, sans-serif;

@font-face {
  font-family: 'proxima_nova_rgregular';
  src: url('./assets/fonts/proximanova-reg-webfont.eot');
  src: url('./assets/fonts/proximanova-reg-webfont.eot?#iefix')
      format('embedded-opentype'),
    url('./assets/fonts/proximanova-reg-webfont.woff2') format('woff2'),
    url('./assets/fonts/proximanova-reg-webfont.woff') format('woff'),
    url('./assets/fonts/proximanova-reg-webfont.ttf') format('truetype'),
    url('./assets/fonts/proximanova-reg-webfont.svg#proxima_nova_rgregular')
      format('svg');
  font-weight: normal;
  font-style: normal;
}

$font__reg: 'proxima_nova_rgregular', Arial, Helvetica, sans-serif;

@font-face {
  font-family: 'proxima_nova_ltsemibold';
  src: url('./assets/fonts/proximanova-sbold-webfont.eot');
  src: url('./assets/fonts/proximanova-sbold-webfont.eot?#iefix')
      format('embedded-opentype'),
    url('./assets/fonts/proximanova-sbold-webfont.woff2') format('woff2'),
    url('./assets/fonts/proximanova-sbold-webfont.woff') format('woff'),
    url('./assets/fonts/proximanova-sbold-webfont.ttf') format('truetype'),
    url('./assets/fonts/proximanova-sbold-webfont.svg#proxima_nova_ltsemibold')
      format('svg');
  font-weight: normal;
  font-style: normal;
}

$font__bold: 'proxima_nova_ltsemibold', Arial, Helvetica, sans-serif;

@font-face {
  font-family: 'proxima_nova_ththin';
  src: url('./assets/fonts/proximanova-thin-webfont.eot');
  src: url('./assets/fonts/proximanova-thin-webfont.eot?#iefix')
      format('embedded-opentype'),
    url('./assets/fonts/proximanova-thin-webfont.woff2') format('woff2'),
    url('./assets/fonts/proximanova-thin-webfont.woff') format('woff'),
    url('./assets/fonts/proximanova-thin-webfont.ttf') format('truetype'),
    url('./assets/fonts/proximanova-thin-webfont.svg#proxima_nova_ththin')
      format('svg');
  font-weight: normal;
  font-style: normal;
}

$font__thin: 'proxima_nova_ththin', Arial, Helvetica, sans-serif;

@font-face {
  font-family: 'proxima_novalight_italic';
  src: url('./assets/fonts/proximanova-lightit-webfont.eot');
  src: url('./assets/fonts/proximanova-lightit-webfont.eot?#iefix')
      format('embedded-opentype'),
    url('./assets/fonts/proximanova-lightit-webfont.woff2') format('woff2'),
    url('./assets/fonts/proximanova-lightit-webfont.woff') format('woff'),
    url('./assets/fonts/proximanova-lightit-webfont.ttf') format('truetype'),
    url('./assets/fonts/proximanova-lightit-webfont.svg#proxima_novalight_italic')
      format('svg');
  font-weight: normal;
  font-style: normal;
}

$font__light--it: 'proxima_novalight_italic', Arial, Helvetica, sans-serif;

* {
  box-sizing: border-box;
  font-family: $font__reg;
  font-weight: normal !important;
  transition: all 0.2s;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: $font__bold;
}

a {
  color: #09a3ed;
  transition: all 0.2s;

  &:hover {
    color: darken(#09a3ed, 10%);
  }
}

#app {
  button,
  input,
  optgroup,
  select,
  textarea,
  p {
    font-weight: normal;
    font-family: $font__reg;
  }

  label {
    font-weight: normal;
    font-family: $font__bold;
  }
}

.view-explanation {
  padding: 0 1.4rem 2rem;
  width: 100%;
}

.view-explanation p {
  max-width: 900px;
  width: 100%;
  color: #666;
  line-height: 1.5 !important;
}

.material-design-icon {
  font-size: 16px;
  top: -0.15rem;
}

.v-select.unsearchable .dropdown-toggle {
  background: #fff;
}

.toast-icons {
  font-style: normal !important;
}

.button__submit {
  background: #09a3ed;
  cursor: pointer;
  border: 0;
  text-align: center;
  display: block;
  color: #fff;
  // font-weight: 700;
  font-size: 1em;
  padding: 15px;
  border-radius: 5px;
  width: 250px;
  transition: 200ms ease-out;
  &:hover {
    transition: 100ms ease-out;
    background: #2498cf;
  }
}

nav.nav {
  position: fixed;
  top: 0;
  left: 200px;
  right: 0;
  background: #fff;
  box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.1);
  height: 60px;
  z-index: 99;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  align-items: center;
}

.submit__container {
  // width: 560px;
  width: auto;
  display: flex;
  flex-direction: row;
  height: 45px;
  align-items: center;

  .locales {
    span {
      margin-right: 10px;
    }

    button {
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 3px;
      padding: 8px 32px;
      margin: 0 0 0 5px;

      &:hover {
        background: #41b883;
        border-color: #41b883;
        color: #fff;
      }

      &:disabled {
        background: #41b883;
        border-color: #41b883;
        color: #fff;
        // cursor: not-allowed;
        pointer-events: none;
      }
    }
  }

  .button__submit {
    padding: 8px 32px;
    width: auto;
    margin-left: 25px;
  }
}

.button__action {
  background: #fff;
  border: 1px solid #09a3ed;
  font-size: 0.9em;
  color: #09a3ed;
  border-radius: 5px;
  padding: 8px 12px;
  margin: auto 0 auto 10px;
  display: flex;
  flex: 0 0 auto;
  flex-flow: row nowrap;
  text-decoration: none;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;

  .icon {
    position: relative;
    top: -2px;
    font-size: 1em;
    margin-right: 5px;
  }

  &:hover {
    border-color: darken(#09a3ed, 20%);
    color: darken(#09a3ed, 20%);
  }

  &.active {
    background: #09a3ed;
    color: #fff;
  }

  &.button__delete {
      border-color: #555;
      color: #555;
  }
}

.input__label {
  color: #888;
  display: block;
  font-size: 0.8em;
  // font-weight: 700;
  text-transform: uppercase;
  margin: 10px 0 10px;
}

.input__text {
  padding: 15px;
  border-radius: 3px;
  outline: none;
  background: #fff;
  font-size: 1.1em;
  box-shadow: none;
  border: 1px solid #aaa;
  transition: 200ms;
  width: 400px;

  &:focus {
    box-shadow: 0 2px 5px 5px lighten(#09a3ed, 40%);
  }
}

@mixin animation($str) {
  -webkit-animation: #{$str};
  -moz-animation: #{$str};
  -ms-animation: #{$str};
  -o-animation: #{$str};
  animation: #{$str};
}

@mixin keyframes($animation-name) {
  @-webkit-keyframes #{$animation-name} {
    @content;
  }
  @-moz-keyframes #{$animation-name} {
    @content;
  }
  @-ms-keyframes #{$animation-name} {
    @content;
  }
  @-o-keyframes #{$animation-name} {
    @content;
  }
  @keyframes #{$animation-name} {
    @content;
  }
}

// form validation
@include keyframes(shakeError) {
  $shake-distance: 0.375rem;
  0% {
    transform: translateX(0);
  }
  15% {
    transform: translateX($shake-distance);
  }
  30% {
    transform: translateX(-$shake-distance);
  }
  45% {
    transform: translateX($shake-distance);
  }
  60% {
    transform: translateX(-$shake-distance);
  }
  75% {
    transform: translateX($shake-distance);
  }
  90% {
    transform: translateX(-$shake-distance);
  }
  100% {
    transform: translateX(0);
  }
}

.error {
  @include animation('shakeError 0.6s running');
  animation-timing-function: ease-in-out;
}

.error__hint {
  display: none;
  color: #f57f6c;
  position: absolute;
  bottom: -3px;
  font-size: 0.8rem;

  &.error__custom {
    bottom: 8px;
  }
}

.error {
  border-color: #f57f6c;

  &.input__text {
    &:focus {
      box-shadow: transparent;
    }
  }
}

.box__shadow {
  box-shadow: 0 5px 15px 3px rgba(0, 0, 0, 0.2);
  transition: box-shadow 100ms ease-out;

  &.box__shadow--link:hover {
    cursor: pointer;
    box-shadow: 0 7px 10px 4px rgba(0, 0, 0, 0.35);
    transition: box-shadow 200ms ease-out;
  }
}

.input__container {
  position: relative;
  margin-bottom: 1rem;
}

.form-group--error .error__hint,
.invalid .error__hint {
  display: block;
}

.form__select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: #fff;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 3px;
  height: 3rem;
  width: 100%;
  padding-left: 5px;
  outline: 0;
  position: relative;

  &:focus {
    box-shadow: 0 2px 5px 5px lighten(#09a3ed, 40%);
  }

  &:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }
  option:not(:checked) {
    color: black; /* prevent <option>s from becoming transparent as well */
  }
}

.card-wrap {
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 3px 7px 2px rgba(0, 0, 0, 0.1);
  color: rgb(51, 51, 51);
  font-size: 14px;
  display: flex;
  border: 1px solid #eee;
  padding: 10px;
  flex-flow: row nowrap;
  width: calc(25% - 20px);
  text-decoration: none;
  transition: all 0.2s;
  margin: 10px;
  &:hover {
    border: 1px solid #888;
    cursor: pointer;
  }
}

.rule__control-group--select {
  position: relative;
  &:after {
    content: '';
    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDI1NSAyNTUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI1NSAyNTU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0iYXJyb3ctZHJvcC1kb3duIj4KCQk8cG9seWdvbiBwb2ludHM9IjAsNjMuNzUgMTI3LjUsMTkxLjI1IDI1NSw2My43NSAgICIgZmlsbD0iIzAwMDAwMCIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=);
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    height: 52px;
    width: 30px;
    right: 5px;
    opacity: 0.2;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 1.4rem;
  }
}
#libraryWrapper .vue-tabs {
  width: 100%;

  .nav-tabs-navigation {
    margin-bottom: 0px;
  }
}

.vue-tags-input .ti-tag {
  position: relative;
  background: #41b883;
  color: #fff;
  border-radius: 3px;
}

.multiselect__tag {
    border-radius: 3px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue